module.exports = __webpack_public_path__ + "img/banner2_4_vi.6972774a.png";